export enum LanguageCode {
  English = 'en',
  German = 'de',
  Serbian = 'sr',
  Japanese = 'ja',
  Italian = 'it',
  French = 'fr',
  Swedish = 'sv',
  Norwegian = 'no',
  Danish = 'da',
  Polish = 'pl',
  Dutch = 'nl',
  Finnish = 'fi',
  Spanish = 'es',
  Catalan = 'ca',
  Galician = 'gl',
  Basque = 'eu',
  Russian = 'ru',
  Portuguese = 'pt',
  Korean = 'ko',
  Slovenian = 'sl',
  Romanian = 'ro',
  Croatian = 'hr',
  Slovakian = 'sk',
  Czech = 'cs',
  Hungarian = 'hu',
}
